/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

// CHILDREN
import Loader from '../../../common/loader/legacy-loaders/Op36Loader-web'
import Placeholder from '../../../common/Placeholder'
import FlagRow from './FlagRow'

class CommunityFlags extends Component {
  render() {
    return <div id='CommunityFlags'>{this._renderFlags()}</div>
  }

  _renderFlags = () => {
    const {
      flags,
      loader,
      toggleFormSection,
      toggleEditFlag,
      deleteFlag,
      t,
    } = this.props

    if (loader) {
      return <Loader message={t('communities.flags.loadingFlags')} />
    }

    if (flags && flags.length > 0) {
      return flags.map(flag => (
        <FlagRow
          flag={flag}
          key={flag.id}
          toggleEditFlag={toggleEditFlag}
          deleteFlag={deleteFlag}
        />
      ))
    }
    return (
      <Placeholder
        title={t('communities.flags.noFlagsCreated')}
        icon={'fa-flag'}
        subtext1={t('communities.flags.emptyStateSubtext1')}
        subtext2={t('communities.flags.emptyStateSubtext2')}
        buttonText={t('communities.flags.newFlag')}
        buttonIcon={'fa-plus'}
        handleClick={() => toggleFormSection('flags')}
      />
    )
  }
}

export default withTranslation()(CommunityFlags)
